var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7542_201081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35498 12.2849V6.29869C5.35498 5.39293 6.09606 4.65186 7.00181 4.65186H18.5296C19.4354 4.65186 20.1765 5.39293 20.1765 6.29869V17.8265C20.1765 18.7323 19.4354 19.4734 18.5296 19.4734H13.2268",
    stroke: "#263238",
    strokeWidth: 1.64683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26533 20.0579L4.66333 17.4559L7.27356 14.8457",
    stroke: "#263238",
    strokeWidth: 1.64683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66309 17.4561H10.8799",
    stroke: "#263238",
    strokeWidth: 1.64683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4084 10.4321L16.0104 13.0341L13.4001 15.6444",
    stroke: "#263238",
    strokeWidth: 1.64683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0103 13.0347H9.80176",
    stroke: "#263238",
    strokeWidth: 1.64683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7542_201081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.16,
    height: 17.053,
    fill: "white",
    transform: "translate(3.83984 3.82861)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.ba5987691f9cbb17923ab8dd9b55f7ef.svg";
export { ForwardRef as ReactComponent };